"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var RTC_METRICS = exports.default = {
  APP_ID: 'FFB51ED5-4319-4C55-8303-B1F2FCCDE231'
};
//# sourceMappingURL=constants.js.map
